import FiltersListApiHOC from './FiltersListApiHOC';
import ProductsListApiHOC from './ProductsListApiHOC';
import ProductApiHOC from './ProductApiHOC';
import AddProductApiHOC from './AddProductApiHOC';
import OrdersApiHOC from './OrdersApiHOC';

export { default as reducers } from './reducers';

export default {
  FiltersListApiHOC,
  ProductsListApiHOC,
  ProductApiHOC,
  AddProductApiHOC,
  OrdersApiHOC,
};



// WEBPACK FOOTER //
// ./src/components/apiHOCs/index.js